<script>
import { h } from 'vue';
import { Form, FormItem, Button, Tag, Input, Image, InputNumber } from 'ant-design-vue';
import { DolIcon } from 'dolphin-framework-vue';
import DolSelect from '@/components/dolphin-ant-design/form/dol-select.vue';

const INPUT_TYPE = {
  'select': DolSelect,
  'dict': DolSelect,
  'tagArray': DolSelect,
  'ref': DolSelect,
}

export default {
  name: 'dol-form',
  components: { DolSelect },
  props: {
    fields: { type: Object, default: () => [] },
    form: { type: Object, default: () => ({})},
    layout: { type: String, default: 'inline' },
  },
  computed: {
    innerFields(){
      return this.fields;
    },
  },
  data () {
    return {};
  },
  methods: {
    refresh(){
      this.$emit('refresh');
    }
  },
  render(){
    const formParams = {
      class: `dol-form`,
      layout: this.layout,
    };
    const formChildren = [];

    // 表单项
    this.innerFields.forEach(field => {
      const formItemParams = {
        label: field.title,
      };

      const inputComponent = INPUT_TYPE[field.inputType] || INPUT_TYPE[field.fieldType] || Input;
      const inputParams = {
        value: this.form[field.dataIndex],
        "onUpdate:value": v => this.form[field.dataIndex] = v,
        ...field.inputParams,
      };
      if(field.dictCode) inputParams.dictCode = field.dictCode;
      const formInput = h(inputComponent, inputParams, () => undefined);

      formChildren.push(h(FormItem, formItemParams, () => [formInput]));
    });

    return h(Form, formParams, () => formChildren);
  },
}
</script>

<style lang="scss">

</style>
